import gql from 'graphql-tag';

export default gql`
  fragment automaticMailActionFragment on AutomaticMailAction {
    id
  }
`;
